<template>
  <div class="containerWrap">
    <!-- pc일 경우 컨텐츠 영역 감싸는 마크업 추가  -->

    <div id="article" class="contentSection main_section ver2">
      <div class="wrap_box wrap1">
        <section class="box win win645">
          <header>
            <h2>로또 6/45</h2>
          </header>
          <div class="content">
            <h3>
              <a id="goByWin1" href="/?method=byWin&amp;wiselog=C_A_1_1"
                ><strong id="lottoDrwNo">{{ lotteryData.lottery645.data[0].round }}</strong>
                <span class="txt">당첨결과</span>
                <span class="date" id="drwNoDate">({{ lotteryData.lottery645.data[0].date }}) 추첨</span></a
              >
            </h3>
            <p class="num">
              <a id="numView" href="/?method=byWin&amp;wiselog=C_A_1_1">
                <span class="accessibility">당첨번호</span>
                <span
                  id="drwtNo1"
                  :class="[
                    'ball_645',
                    lotteryData.lottery645.data[0].prize[0] < 10
                      ? 'ball1'
                      : lotteryData.lottery645.data[0].prize[0] < 20
                      ? 'ball2'
                      : lotteryData.lottery645.data[0].prize[0] < 30
                      ? 'ball3'
                      : lotteryData.lottery645.data[0].prize[0] < 40
                      ? 'ball4'
                      : 'ball5',
                  ]"
                  >{{ lotteryData.lottery645.data[0].prize[0] }}</span
                >
                <span
                  id="drwtNo2"
                  :class="[
                    'ball_645',
                    lotteryData.lottery645.data[0].prize[1] < 10
                      ? 'ball1'
                      : lotteryData.lottery645.data[0].prize[1] < 20
                      ? 'ball2'
                      : lotteryData.lottery645.data[0].prize[1] < 30
                      ? 'ball3'
                      : lotteryData.lottery645.data[0].prize[1] < 40
                      ? 'ball4'
                      : 'ball5',
                  ]"
                  >{{ lotteryData.lottery645.data[0].prize[1] }}</span
                >
                <span
                  id="drwtNo3"
                  :class="[
                    'ball_645',
                    lotteryData.lottery645.data[0].prize[2] < 10
                      ? 'ball1'
                      : lotteryData.lottery645.data[0].prize[2] < 20
                      ? 'ball2'
                      : lotteryData.lottery645.data[0].prize[2] < 30
                      ? 'ball3'
                      : lotteryData.lottery645.data[0].prize[2] < 40
                      ? 'ball4'
                      : 'ball5',
                  ]"
                  >{{ lotteryData.lottery645.data[0].prize[2] }}</span
                >
                <span
                  id="drwtNo4"
                  :class="[
                    'ball_645',
                    lotteryData.lottery645.data[0].prize[3] < 10
                      ? 'ball1'
                      : lotteryData.lottery645.data[0].prize[3] < 20
                      ? 'ball2'
                      : lotteryData.lottery645.data[0].prize[3] < 30
                      ? 'ball3'
                      : lotteryData.lottery645.data[0].prize[3] < 40
                      ? 'ball4'
                      : 'ball5',
                  ]"
                  >{{ lotteryData.lottery645.data[0].prize[3] }}</span
                >
                <span
                  id="drwtNo5"
                  :class="[
                    'ball_645',
                    lotteryData.lottery645.data[0].prize[4] < 10
                      ? 'ball1'
                      : lotteryData.lottery645.data[0].prize[4] < 20
                      ? 'ball2'
                      : lotteryData.lottery645.data[0].prize[4] < 30
                      ? 'ball3'
                      : lotteryData.lottery645.data[0].prize[4] < 40
                      ? 'ball4'
                      : 'ball5',
                  ]"
                  >{{ lotteryData.lottery645.data[0].prize[4] }}</span
                >
                <span
                  id="drwtNo6"
                  :class="[
                    'ball_645',
                    lotteryData.lottery645.data[0].prize[5] < 10
                      ? 'ball1'
                      : lotteryData.lottery645.data[0].prize[5] < 20
                      ? 'ball2'
                      : lotteryData.lottery645.data[0].prize[5] < 30
                      ? 'ball3'
                      : lotteryData.lottery645.data[0].prize[5] < 40
                      ? 'ball4'
                      : 'ball5',
                  ]"
                  >{{ lotteryData.lottery645.data[0].prize[5] }}</span
                >
                <span class="bonus">보너스번호</span>
                <span
                  id="bnusNo"
                  :class="[
                    'ball_645',
                    lotteryData.lottery645.data[0].prize[6] < 10
                      ? 'ball1'
                      : lotteryData.lottery645.data[0].prize[6] < 20
                      ? 'ball2'
                      : lotteryData.lottery645.data[0].prize[6] < 30
                      ? 'ball3'
                      : lotteryData.lottery645.data[0].prize[6] < 40
                      ? 'ball4'
                      : 'ball5',
                  ]"
                  >{{ lotteryData.lottery645.data[0].prize[6] }}</span
                >
              </a>
            </p>

            <div id="winnerId">
              <dl class="result">
                <dt>1등 총 당첨금</dt>
                <dd>
                  <strong>{{ lotteryData.lottery645.data[0].cap.totalAmount }}원</strong>({{ lotteryData.lottery645.data[0].cap.games }}명 /
                  {{ lotteryData.lottery645.data[0].cap.perGameAmount }})
                </dd>
              </dl>
            </div>
            <a class="go prev" href="javascript:getLottoNumber('before');">이전 회차 당첨정보 보기</a>
            <a class="go next" href="javascript:getLottoNumber('');">다음 회차 당첨정보 보기</a>
            <div class="btn">
              <span class="area"><a class="btn_common smid" href="/?method=byWin&amp;wiselog=C_A_1_2">회차별 당첨결과</a></span>
              <span class="area"><a class="btn_common smid gblu" href="/?method=buyLotto&amp;wiselog=C_A_1_3">구매하기</a></span>
            </div>
          </div>
        </section>

        <!-- 연금복권 720 Start-->
        <section class="box win win720" id="win720">
          <header>
            <h2>연금복권720+</h2>
          </header>

          <div id="tipRolling">
            <dl class="rolling_tip">
              <dt>구매팁!</dt>
              <dd>
                <div id="tip_list">
                  <ul>
                    <li v-for="(item, i) in lotteryData.tips" :key="i">{{ item }}</li>
                  </ul>
                </div>
              </dd>
            </dl>
          </div>

          <div class="content">
            <h3>
              <a href="/?method=win720&amp;wiselog=C_A_4_1"
                ><strong id="drwNo720">{{ lotteryData.lottery720[0].round }}</strong>
                <span class="txt">당첨결과</span>
                <span id="drawDate720" class="date">({{ lotteryData.lottery720[0].date.replace('기준', '') }} 추첨)</span></a
              >
            </h3>
            <!-- 1등 -->
            <div id="number720add">
              <div class="win_num_wrap">
                <dl class="win_money">
                  <dt>1등</dt>
                  <dd>월 <span class="num">700</span>만원 x <span class="num">20</span>년</dd>
                </dl>
                <div class="win720_num">
                  <div class="group">
                    <span class="num"
                      ><span>{{ lotteryData.lottery720[0].prize[0] }}</span></span
                    ><em>조</em>
                  </div>
                  <span class="num al720_color1"
                    ><span>{{ lotteryData.lottery720[0].prize[1] }}</span></span
                  ><span class="num al720_color2"
                    ><span>{{ lotteryData.lottery720[0].prize[2] }}</span></span
                  ><span class="num al720_color3"
                    ><span>{{ lotteryData.lottery720[0].prize[3] }}</span></span
                  ><span class="num al720_color4"
                    ><span>{{ lotteryData.lottery720[0].prize[4] }}</span></span
                  ><span class="num al720_color5"
                    ><span>{{ lotteryData.lottery720[0].prize[5] }}</span></span
                  ><span class="num al720_color6"
                    ><span>{{ lotteryData.lottery720[0].prize[6] }}</span></span
                  >
                </div>
              </div>
              <div class="win_num_wrap">
                <dl class="win_money">
                  <dt>2등</dt>
                  <dd>월 <span class="num">100</span>만원 x <span class="num">10</span>년</dd>
                </dl>
                <div class="win720_num">
                  <span class="num al720_color1"
                    ><span>{{ lotteryData.lottery720[0].prize[7] }}</span></span
                  ><span class="num al720_color2"
                    ><span>{{ lotteryData.lottery720[0].prize[8] }}</span></span
                  ><span class="num al720_color3"
                    ><span>{{ lotteryData.lottery720[0].prize[9] }}</span></span
                  ><span class="num al720_color4"
                    ><span>{{ lotteryData.lottery720[0].prize[10] }}</span></span
                  ><span class="num al720_color5"
                    ><span>{{ lotteryData.lottery720[0].prize[11] }}</span></span
                  ><span class="num al720_color6"
                    ><span>{{ lotteryData.lottery720[0].prize[12] }}</span></span
                  >
                </div>
              </div>
              <div class="win_num_wrap tb_line">
                <dl class="win_money">
                  <dt>보너스</dt>
                  <dd>월 <span class="num">100</span>만원 x <span class="num">10</span>년</dd>
                </dl>
                <div class="win720_num">
                  <div class="group bonus">
                    <span class="num"><span>각</span></span
                    ><em>조</em>
                  </div>
                  <span class="num al720_color1"
                    ><span>{{ lotteryData.lottery720[0].prize[7] }}</span></span
                  ><span class="num al720_color2"
                    ><span>{{ lotteryData.lottery720[0].prize[8] }}</span></span
                  ><span class="num al720_color3"
                    ><span>{{ lotteryData.lottery720[0].prize[9] }}</span></span
                  ><span class="num al720_color4"
                    ><span>{{ lotteryData.lottery720[0].prize[10] }}</span></span
                  ><span class="num al720_color5"
                    ><span>{{ lotteryData.lottery720[0].prize[11] }}</span></span
                  ><span class="num al720_color6"
                    ><span>{{ lotteryData.lottery720[0].prize[12] }}</span></span
                  >
                </div>
              </div>
            </div>
            <!-- 버튼 -->
            <a class="go prev" href="javascript:;">이전 회차 당첨정보 보기</a>
            <a class="go next" href="javascript:;">다음 회차 당첨정보 보기</a>
            <div class="btn">
              <span class="area"><a class="btn_common smid navy" href="/?method=highWin&amp;wiselog=C_D_3_8">당첨자 인터뷰 보기</a></span>
              <span class="area"><a class="btn_common smid" href="/?method=win720&amp;wiselog=C_A_4_2">회차별 당첨결과</a></span>
              <span class="area"><a class="btn_common smid gblu" href="/?method=game720Method&amp;wiselog=C_A_4_3">구매하기</a></span>
            </div>
          </div>
        </section>
        <!-- 연금복권 720 END -->
        <section class="box speetto-new win">
          <header>
            <h2>즉석식 인쇄복권</h2>
          </header>
          <div class="content">
            <!-- 190318 slide영역으로 변경 -->
            <div class="slick_slide spt_group">
              <div class="slide_inner slick-slider">
                <div class="slide_item slick-slide slick-current slick-active" aria-hidden="false" style="width: 220px">
                  <div id="speetto2000" class="speetto-result" style="padding-top: 0px">
                    <strong class="tit">{{ lotteryData.speetto[0].name }} {{ lotteryData.speetto[0].round }}회</strong>
                    <!-- 190313 스피또 복권이미지영역 마크업 추가 -->
                    <div class="img_area" style="padding-bottom: 5px">
                      <img :src="lotteryData.speetto[0].image" alt="스피또 복권 이미지" />
                    </div>
                    <!-- //190313 스피또 복권이미지영역 마크업 추가 -->

                    <span class="btn_common navy" style="float: right">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity">
                      <strong class="tit">상위등위 잔여수량</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">1 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[0].tableData[0][0].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">2 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[0].tableData[0][1].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">3 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[0].tableData[0][2].split('등')[1] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[0].tableData[1][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[0].tableData[1][1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[0].tableData[1][2] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[0].tableData[2][0].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[0].tableData[2][1].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[0].tableData[2][2].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                    <span class="btn_common navy" style="float: right; margin-top: 4px">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity" style="margin-top: 5px">
                      <strong class="tit">판매점 입고율</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 66.6%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[0].tableData[3][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span
                              ><em class="num" style="font-size: 11px">{{ lotteryData.speetto[0].tableData[3][1].split(' ')[0] }}</em> %</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="slide_item slick-slide" aria-hidden="true" style="width: 220px">
                  <div id="speetto2000" class="speetto-result" style="padding-top: 0px">
                    <strong class="tit">{{ lotteryData.speetto[1].name }} {{ lotteryData.speetto[1].round }}회</strong>
                    <!-- 190313 스피또 복권이미지영역 마크업 추가 -->
                    <div class="img_area" style="padding-bottom: 5px">
                      <img :src="lotteryData.speetto[1].image" alt="스피또 복권 이미지" />
                    </div>
                    <!-- //190313 스피또 복권이미지영역 마크업 추가 -->

                    <span class="btn_common navy" style="float: right">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity">
                      <strong class="tit">상위등위 잔여수량</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">1 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[1].tableData[0][0].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">2 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[1].tableData[0][1].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">3 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[1].tableData[0][2].split('등')[1] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[1].tableData[1][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[1].tableData[1][1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[1].tableData[1][2] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[1].tableData[2][0].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[1].tableData[2][1].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[1].tableData[2][2].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                    <span class="btn_common navy" style="float: right; margin-top: 4px">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity" style="margin-top: 5px">
                      <strong class="tit">판매점 입고율</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 66.6%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[1].tableData[3][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span
                              ><em class="num" style="font-size: 11px">{{ lotteryData.speetto[1].tableData[3][1].split(' ')[0] }}</em> %</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="slide_item slick-slide" aria-hidden="true" style="width: 220px">
                  <div id="speetto2000" class="speetto-result" style="padding-top: 0px">
                    <strong class="tit">{{ lotteryData.speetto[2].name }} {{ lotteryData.speetto[2].round }}회</strong>
                    <!-- 190313 스피또 복권이미지영역 마크업 추가 -->
                    <div class="img_area" style="padding-bottom: 5px">
                      <img :src="lotteryData.speetto[2].image" alt="스피또 복권 이미지" />
                    </div>
                    <!-- //190313 스피또 복권이미지영역 마크업 추가 -->

                    <span class="btn_common navy" style="float: right">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity">
                      <strong class="tit">상위등위 잔여수량</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">1 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[2].tableData[0][0].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">2 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[2].tableData[0][1].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">3 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[2].tableData[0][2].split('등')[1] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[2].tableData[1][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[2].tableData[1][1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[2].tableData[1][2] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[2].tableData[2][0].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[2].tableData[2][1].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[2].tableData[2][2].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                    <span class="btn_common navy" style="float: right; margin-top: 4px">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity" style="margin-top: 5px">
                      <strong class="tit">판매점 입고율</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 66.6%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[2].tableData[3][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span
                              ><em class="num" style="font-size: 11px">{{ lotteryData.speetto[2].tableData[3][1].split(' ')[0] }}</em> %</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="slide_item slick-slide" aria-hidden="true" style="width: 220px">
                  <div id="speetto2000" class="speetto-result" style="padding-top: 0px">
                    <strong class="tit">{{ lotteryData.speetto[3].name }} {{ lotteryData.speetto[3].round }}회</strong>
                    <!-- 190313 스피또 복권이미지영역 마크업 추가 -->
                    <div class="img_area" style="padding-bottom: 5px">
                      <img :src="lotteryData.speetto[3].image" alt="스피또 복권 이미지" />
                    </div>
                    <!-- //190313 스피또 복권이미지영역 마크업 추가 -->

                    <span class="btn_common navy" style="float: right">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity">
                      <strong class="tit">상위등위 잔여수량</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">1 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[3].tableData[0][0].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">2 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[3].tableData[0][1].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">3 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[3].tableData[0][2].split('등')[1] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[3].tableData[1][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[3].tableData[1][1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[3].tableData[1][2] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[3].tableData[2][0].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[3].tableData[2][1].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[3].tableData[2][2].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                    <span class="btn_common navy" style="float: right; margin-top: 4px">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity" style="margin-top: 5px">
                      <strong class="tit">판매점 입고율</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 66.6%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[3].tableData[3][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span
                              ><em class="num" style="font-size: 11px">{{ lotteryData.speetto[3].tableData[3][1].split(' ')[0] }}</em> %</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="slide_item slick-slide" aria-hidden="true" style="width: 220px">
                  <div id="speetto2000" class="speetto-result" style="padding-top: 0px">
                    <strong class="tit">{{ lotteryData.speetto[4].name }} {{ lotteryData.speetto[4].round }}회</strong>
                    <!-- 190313 스피또 복권이미지영역 마크업 추가 -->
                    <div class="img_area" style="padding-bottom: 5px">
                      <img :src="lotteryData.speetto[4].image" alt="스피또 복권 이미지" />
                    </div>
                    <!-- //190313 스피또 복권이미지영역 마크업 추가 -->

                    <span class="btn_common navy" style="float: right">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity">
                      <strong class="tit">상위등위 잔여수량</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">1 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[4].tableData[0][0].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">2 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[4].tableData[0][1].split('등')[1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">3 등</span>
                            <span style="font-size: 11px; line-height: 10px; height: 15px">{{ lotteryData.speetto[4].tableData[0][2].split('등')[1] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[4].tableData[1][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[4].tableData[1][1] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[4].tableData[1][2] }}</span>
                          </li>
                        </ul>
                        <ul style="border-top: 0px solid">
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[4].tableData[2][0].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[4].tableData[2][1].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                          <li style="width: 33.3%">
                            <span style="font-size: 11px"
                              ><em class="num">{{ lotteryData.speetto[4].tableData[2][2].split(' ')[0] }}</em> 매</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                    <span class="btn_common navy" style="float: right; margin-top: 4px">
                      <a href="javascript:openSpeettoPopup();" title="안내정보" tabindex="0"><strong class="tit" style="font-size: 12px; margin: 2px">안내사항</strong></a>
                    </span>
                    <div class="quantity" style="margin-top: 5px">
                      <strong class="tit">판매점 입고율</strong>
                      <a href="/?method=speettoWin&amp;lottoId=SP2000&amp;wiselog=C_A_3_1" tabindex="0">
                        <ul>
                          <li style="width: 66.6%">
                            <span style="font-size: 11px">{{ lotteryData.speetto[4].tableData[3][0] }}</span>
                          </li>
                          <li style="width: 33.3%">
                            <span
                              ><em class="num" style="font-size: 11px">{{ lotteryData.speetto[4].tableData[3][1].split(' ')[0] }}</em> %</span
                            >
                          </li>
                        </ul>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div style='color: #fff;font-size: 11.5px;position: absolute;left: 0px;margin-left: 38px;margin-right: 38px;'>
				<strong style='color:#fff;'>* 출고율</strong><br/>
				동행복권에서 판매점으로 공급한 복권의 수량을 발행량으로 나눈 값으로, 실제 소비자에게 판매된 수량이 아닙니다.<br/>(출고율 = 출고량 / 발행량)
				</div> -->
        </section>
        <!-- //190225 신규 마크업 끝 -->
        <!-- 로또 구입 관련 메세지 팝업 : 접근성 준수 처리를 위해 openPopLayer($('#alertLotto1'),$('#btnBuyLotto')); 이렇게 openPopLayer 함수 태워서 띄워주세요. -->
        <div id="alertLotto1" class="popup_alert" style="display: none">
          <div class="content">
            <p class="txt1">
              로또6/45복권 로또는<br />
              <strong>오전 6시부터 밤 12시까지만 구매</strong>할 수 있습니다.
            </p>
            <p class="txt2">
              토요일(추첨일) 오후 8시부터 <br />
              일요일 오전 6시이전까지는 구매불가합니다.
            </p>
          </div>
          <div class="btns">
            <a class="btn_common mid close" href="#">닫기</a>
          </div>
        </div>
        <div id="alertLotto2" class="popup_alert" style="display: none">
          <div class="content">
            <p class="txt1">
              로또6/45 <strong>인터넷 판매수량이 <br />모두 소진</strong>되었습니다.
            </p>
            <p class="txt2">다음 회차를 이용해 주세요.</p>
          </div>
          <div class="btns">
            <a class="btn_common mid close" href="#">닫기</a>
          </div>
        </div>
        <!-- //로또 구입 관련 메세지 팝업 -->
      </div>

      <!-- 당첨자인터뷰 -->
      <div class="wrap_box">
        <section class="box interview_list">
          <a class="more" href="/?method=highWin&amp;wiselog=C_D_3_8">인터뷰 전체보기</a>
          <ul class="list">
            <li>
              <a href="/?method=highWinView&amp;wiselog=C_C_1_1&amp;txtNo=14771">
                <p class="tit">
                  <strong>스피또1000</strong>
                  <strong> [1등] </strong>
                </p>
                <div class="img_area">
                  <img width="194px" height="120px" src="~@/assets/images/dhb/1731634040504.png" alt="당첨자 인터뷰" />
                </div>
                <p class="txt">복권 1등에 너무 떨렸다는 당첨자 사연</p>
              </a>
            </li>

            <li>
              <a href="/?method=highWinView&amp;wiselog=C_C_1_1&amp;txtNo=14763">
                <p class="tit">
                  <strong>연금복권720+</strong>
                  <strong> [1등] </strong>
                </p>
                <div class="img_area">
                  <img width="194px" height="120px" src="~@/assets/images/dhb/1730363099675.png" alt="당첨자 인터뷰" />
                </div>
                <p class="txt">남자친구와 데이트 중 산 복권 1등 당첨</p>
              </a>
            </li>

            <li>
              <a href="/?method=highWinView&amp;wiselog=C_C_1_1&amp;txtNo=14761">
                <p class="tit">
                  <strong>스피또1000</strong>
                  <strong> [1등] </strong>
                </p>
                <div class="img_area">
                  <img width="194px" height="120px" src="~@/assets/images/dhb/1730193436014.png" alt="당첨자 인터뷰" />
                </div>
                <p class="txt">돼지들이 뛰어와 안기는 꿈 꾸고 1등 당첨</p>
              </a>
            </li>
          </ul>
        </section>
      </div>

      <div class="wrap_box wrap3">
        <div class="box board">
          <section id="divBoard" class="inner">
            <div class="wrap wrap1" :class="{ active: boardTab === 'notice' }">
              <h2>
                <a href="javascript:;" @click="updateBoardTab('notice')">공지사항</a>
              </h2>
              <ul id="divBoard1">
                <li v-for="(v, i) in noticeList" :key="i">
                  <a :href="`/service.do?method=noticeView&serial=${v.ibd_idx}`">
                    <strong :title="v.ibd_title">{{ v.ibd_title }}</strong> </a
                  ><span class="date">{{ $moment(v.ibd_reg_datetime).format('YYYY. MM. DD') }}</span>
                </li>
              </ul>
              <a class="more" href="/service.do?method=noticeList&wiselog=C_C_1_2">공지사항 더 보기</a>
            </div>
            <div class="wrap wrap2" :class="{ active: boardTab === 'event' }">
              <h2>
                <a href="javascript:;" @click="updateBoardTab('event')">이벤트</a>
              </h2>
              <ul id="divBoard2">
                <li v-for="(v, i) in eventList" :key="i">
                  <a :href="`/service.do?method=eventView&serial=${v.ibd_idx}`">
                    <strong :title="v.ibd_title">{{ v.ibd_title }}</strong> </a
                  ><span class="date">{{ $moment(v.ibd_reg_datetime).format('YYYY. MM. DD') }}</span>
                </li>
              </ul>
              <a class="more" href="/service.do?method=eventList&wiselog=C_C_1_2">이벤트 더 보기</a>
            </div>
          </section>
        </div>
        <section class="box fund">
          <h2><span>판매액의 42%이상</span>이 복권기금이 <br />되어 소외계층에 사용되고 있습니다.</h2>
          <ul>
            <li>법정배분사업</li>
            <li>주거안정사업</li>
            <li>소외계층사업</li>
            <li>문화예술사업</li>
          </ul>
          <p><span>2024년 복권기금 누적액</span><strong>₩ 2,800,169,950,195</strong></p>
          <a class="link" href="/?method=fundInfo&amp;wiselog=C_C_2_1">복권기금 알아보기</a>
        </section>
        <div class="box happyplus">
          <a href="/?method=joinNewsLetterInput&amp;wiselog=C_C_2_2"
            ><strong>행복더하기 신청</strong><span>매일 새로운 복권소식과 <br />함께하세요.</span></a
          >
        </div>
        <section class="box quicklink">
          <h2 class="accessibility">바로가기</h2>
          <ul>
            <!-- <li class="q1">
              <a href="https://cafe.naver.com/dhlottery" target="_blank" title="새창(동행복권 카페로 이동)"
                ><span><strong>동행복권 Cafe</strong>함께하는 재미와 이벤트!</span></a
              >
            </li> -->
            <li class="q2">
              <a href="https://blog.naver.com/donghanglottery1004" target="_blank" title="새창(동행복권 블로그로 이동)"
                ><span><strong>동행복권 Blog</strong>다양한 재미가 팡팡!</span></a
              >
            </li>
            <li class="q3">
              <a href="https://www.facebook.com/donghanglottery/" target="_blank" title="새창(동행복권 페이스북으로 이동)"
                ><span><strong>동행복권 Facebook</strong>친구신청으로 이벤트 정보가 쏙쏙!</span></a
              >
            </li>
            <li class="q4">
              <a href="https://www.youtube.com/channel/UCEk3VwaA6e4H9TW1vSXOjDA/featured" target="_blank" title="새창(동행복권 유투브로 이동)"
                ><span><strong>동행복권 YouTube</strong>복권에 대한 영상 정보를 보는 곳!</span></a
              >
            </li>
            <li class="q5">
              <a href="http://www.happyplus-dhlottery.co.kr" target="_blank" title="새창(동행복권 뉴스레터로 이동)"
                ><span><strong>동행복권 News Letter</strong>복권에 대한 알찬 정보가 있는 곳!</span></a
              >
            </li>
            <!-- <li class="app">
						<ul>
							<li class="a1"><a href="#" onclick="alert('서비스 준비중입니다')"><span><strong>iOS APP</strong>앱스토어 바로가기</span></a></li>
							<li class="a2"><a href="#" onclick="alert('서비스 준비중입니다')"><span><strong>안드로이드 APP</strong>원스토어 바로가기</span></a></li>
							<li><a href="https://itunes.apple.com/kr/app/id1444390490" target="_blank" title="새창(동행복권 iOS 앱 다운로드 페이지로 이동)"><span><strong>iOS APP</strong>앱 스토어 바로가기</span></a></li>
							<li><a href="http://onesto.re/0000734850" target="_blank" title="새창(동행복권 안드로이드 앱 다운로드페이지로 이동)"><span><strong>안드로이드 APP</strong>원 스토어 바로가기</span></a></li>
						</ul>
					
					</li> -->
            <li class="q6">
              <a href="#"
                ><span><strong>동행복권 공식 APP</strong>모든 복권 정보가 한곳에!</span></a
              >
            </li>
          </ul>
        </section>
        <section class="box care">
          <h2>도박중독, 복권과몰입<br />전문 상담기구</h2>
          <strong class="name">동행클린센터</strong>
          <p>도박문제 전문상담 <strong>080-800-0501</strong></p>
          <!-- 181226 링크추가 -->
          <a href="https://clean.dhlottery.co.kr/" target="_blank" title="새창(동행클린센터 페이지로 이동)" class="link">동행클린센터 페이지로 이동하기</a>
          <ul>
            <li class="s1">
              <a href="/?method=campainTest&amp;wiselog=C_C_3_1">셀프 진단평가</a>
            </li>
            <li class="s2">
              <a href="/?method=campainProgram&amp;wiselog=C_C_3_1">셀프 구매계획</a>
            </li>
            <li class="s3">
              <a href="/?method=campainProgram2&amp;wiselog=C_C_3_1">셀프 휴식계획</a>
            </li>
          </ul>
        </section>
      </div>

      <div class="link_out">
        <ul class="bottom_banner clearfx">
          <li>
            <a href="http://www.bokgwon.go.kr/" title="복권위원회" target="_blank"><img src="~@/assets/images/dhb/img_link1.gif" alt="복권위원회" /></a>
          </li>
          <li>
            <a href="http://www.ngcc.go.kr/" title="사행산업통합감독위원회" target="_blank"><img src="~@/assets/images/dhb/img_link2.gif" alt="사행산업통합감독위원회" /></a>
          </li>
          <li>
            <a href="http://www.kcgp.or.kr/" title="한국도박문제예방치유원" target="_blank"><img src="~@/assets/images/dhb/img_link3.gif" alt="한국도박문제예방치유원" /></a>
          </li>
          <li>
            <a href="http://www.world-lotteries.org" title="World Lottery Association" target="_blank"
              ><img src="~@/assets/images/dhb/img_link4.gif" alt="WLA(World Lottery Association)"
            /></a>
          </li>
          <li>
            <a href="http://www.asiapacific-lotteries.com" title="Asia Pacific Lottery Association" target="_blank"
              ><img src="~@/assets/images/dhb/img_link5.gif" alt="APLA(Asia Pacific Lottery Association)"
            /></a>
          </li>
        </ul>
      </div>
    </div>

    <iframe name="wiseForm" id="wiseForm" width="0" height="0" title="wiselog"></iframe>
    <form name="wisefrm" id="wisefrm" method="post"></form>

    <!--//모달팝업레이어 추가-->
  </div>

  <div class="popup-box" ref="popupBox">
    <template v-for="(v, i) in popupList" :key="i">
      <div
        class="popup-container popup"
        :class="`popup-position-${i + 1}`"
        :style="
          i % 3 === 0
            ? popupPosLeftArr[0]
            : i % 3 === 1
            ? popupPosLeftArr[1]
            : i % 3 === 2
            ? popupPosLeftArr[2]
            : {}
        "
        v-if="!$cookies.get(`popup_${v.ibd_idx}`)"
        :ref="`p_${v.ibd_idx}`"
      >
        <div
          class="popup-contents has-img"
          v-html="v.ibd_contents"
          v-if="v.ibd_contents.includes('img')"
        ></div>
        <div class="popup-contents" v-html="v.ibd_contents" v-else></div>
        <div class="popup-footer">
          <div>
            <input
              type="checkbox"
              :id="`popup_${v.ibd_idx}`"
              :name="`popup_${v.ibd_idx}`"
              :ref="`popup_${v.ibd_idx}`"
              checked
            />
            <label :for="`popup_${v.ibd_idx}`">24시간동안 열지않음</label>
          </div>
          <div @click="closePopup(v.ibd_idx)" class="popup_close">
            <i class="mdi mdi-close"></i>
            <span>닫기</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ref } from 'vue';
import MainBoardWidget from '@/components/Widget/MainBoardWidget';
import MainTransactionWidget from '@/components/Widget/MainTransactionWidget';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

jQuery(function ($) {
  function layer_open(el) {
    $('.layer').fadeIn();
    const temp = $('#' + el);
    if (temp.outerHeight() < $(document).height()) temp.css('margin-top', '-' + temp.outerHeight() / 2 + 'px');
    else temp.css('top', '0px');
    if (temp.outerWidth() < $(document).width()) temp.css('margin-left', '-' + temp.outerWidth() / 2 + 'px');
    else temp.css('left', '0px');
  }

  $('#layer_open').click(function () {
    layer_open('layer1');
    return false;
  });

  $('#layer_close').click(function () {
    $('.layer').fadeOut();
    return false;
  });
});

function goWiseLogMain(wiselog) {
  if (wiselog != undefined && wiselog != 'undefined' && wiselog != '') {
    const f = document.wisefrm;
    f.target = 'wiseForm';
    f.action = '/common.do?method=wiselog' + wiselog;
    f.submit();
    f.target = '_self';
  }
}

export default {
  name: 'App',
  components: {
    MainBoardWidget,
    MainTransactionWidget,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Navigation, Autoplay, Pagination],
    };
  },
  data() {
    return {
      boardTab: 'notice',
      value: ref(new Date()),
      hotMatchList: [],
      hotMatchInitList: [],
      liveMatchList: [],
      liveMatchInitList: [],
      hotSportsTypeList: [],
      liveSportsTypeList: [],
      hotSports: '',
      liveSports: '',
      noticeList: [],
      eventList: [],
      hover: null,
      selectedBoard: 'notice',
      selectedRealtime: 'deposit',
      depositList: [],
      withdrawalList: [],
      gameConfig: [],
      lotteryData: {
        lottery720: [
          { round: '242회', date: '2024-12-19 기준', prize: ['1', '3', '2', '3', '1', '6', '4', '4', '3', '6', '9', '6', '6'] },
          { round: '241회', date: '2024-12-12 기준', prize: ['2', '1', '0', '6', '7', '1', '6', '9', '8', '7', '8', '6', '8'] },
          { round: '240회', date: '2024-12-05 기준', prize: ['4', '4', '4', '6', '6', '4', '8', '7', '6', '1', '5', '5', '5'] },
          { round: '239회', date: '2024-11-28 기준', prize: ['4', '2', '7', '7', '3', '2', '6', '1', '6', '0', '7', '6', '4'] },
          { round: '238회', date: '2024-11-21 기준', prize: ['5', '9', '8', '8', '9', '4', '2', '2', '9', '1', '0', '7', '0'] },
        ],
        lottery645: {
          data: [
            { round: '1150', date: '2024-12-14', prize: ['8', '9', '18', '35', '39', '45', '25'], cap: { games: '17', totalAmount: '267억', perGameAmount: '16억원' } },
            { round: '1149', date: '2024-12-07', prize: ['8', '15', '19', '21', '32', '36', '38'], cap: { games: '17', totalAmount: '274억', perGameAmount: '16억원' } },
            { round: '1148', date: '2024-11-30', prize: ['3', '6', '13', '15', '16', '22', '32'], cap: { games: '13', totalAmount: '270억', perGameAmount: '21억원' } },
            { round: '1147', date: '2024-11-23', prize: ['7', '11', '24', '26', '27', '37', '32'], cap: { games: '8', totalAmount: '266억', perGameAmount: '33억원' } },
            { round: '1146', date: '2024-11-16', prize: ['6', '11', '17', '19', '40', '43', '28'], cap: { games: '11', totalAmount: '278억', perGameAmount: '25억원' } },
          ],
          next: { nextDate: '2024-12-20 23:55 기준', expectAmount: '17,070,784,097', accumAmount: '70,978,311,000' },
        },
        speetto: [
          {
            round: '58',
            name: '스피또2000',
            tableData: [
              ['1등(24-12-20기준)', '2등(24-12-20기준)', '3등(24-12-20기준)'],
              ['10억원', '1억원', '1천만원'],
              ['6매', '18매', '150매'],
              ['24-12-20기준', '6%'],
            ],
            image: 'https://dhlottery.co.kr/img/board/content/1731388478516.png',
          },
          {
            round: '57',
            name: '스피또2000',
            tableData: [
              ['1등(24-12-20기준)', '2등(24-12-20기준)', '3등(24-12-20기준)'],
              ['10억원', '1억원', '1천만원'],
              ['2매', '11매', '63매'],
              ['24-12-20기준', '100%'],
            ],
            image: 'https://dhlottery.co.kr/img/board/content/1726123831326.png',
          },
          {
            round: '89',
            name: '스피또1000',
            tableData: [
              ['1등(24-12-20기준)', '2등(24-12-20기준)', '3등(24-12-20기준)'],
              ['5억원', '2천만원', '1만원'],
              ['7매', '35매', '205,133매'],
              ['24-12-20기준', '73%'],
            ],
            image: 'https://dhlottery.co.kr/img/board/content/1732067056596.png',
          },
          {
            round: '85',
            name: '스피또1000',
            tableData: [
              ['1등(24-12-20기준)', '2등(24-12-20기준)', '3등(24-12-20기준)'],
              ['5억원', '2천만원', '1만원'],
              ['1매', '0매', '8,275매'],
              ['24-12-20기준', '100%'],
            ],
            image: 'https://dhlottery.co.kr/img/board/content/1721958007945.png',
          },
          {
            round: '45',
            name: '스피또500',
            tableData: [
              ['1등(24-12-20기준)', '2등(24-12-20기준)', '3등(24-12-20기준)'],
              ['2억원', '1백만원', '5천원'],
              ['0매', '24매', '55,668매'],
              ['24-12-20기준', '88%'],
            ],
            image: 'https://dhlottery.co.kr/img/board/content/1713318393526.png',
          },
        ],
        tips: [
          '243회차 판매마감까지 앞으로 5일!',
          '모든 조 구매 시 1, 2등 동시 당첨 가능(총 당첨금 21.6억원)',
          '판매점, 인터넷 동일한 세트 구매 시 총 당첨금 43.2억원',
          '원하는 번호가 있다면 지금 바로 구매하기!',
          '세트구매란? 동일한 6자리 번호를 1조~5조까지 모두 구입',
          '로또6/45보다 1.6배 높은 당첨 기회',
          '안정적인 생활을 위한 연금복권720+',
          '모든 조 구매 시 매월 1,100만원 x 10년 + 700만원 10년',
        ],
      },
      popupList: [],
      popupPosLeftArr: [
        {
          left: '0px',
        },
        {
          left: '542px',
        },
        {
          left: '1084px',
        },
      ],
    };
  },
  beforeMount() {
    this.getBoardList('공지사항');
    this.getBoardList('이벤트');
  },
  mounted() {
    window.$('.spt_group .slide_inner').slick({
      slidesToShow: 1,
      infinite: true,
      arrows: true,
    });

    window.$('#tip_list').vTicker({
      speed: 500,
      pause: 3000,
      animation: 'fade',
      mousePause: false,
      showItems: 3,
    });
    if (this.$store.state.domainInfo.idm_use_sport) {
      // this.getHotMatchList(true);
      // this.getLiveMatchList();
    }
    // this.getRealtimeTsList();

    this.getLotteryData();
    this.getPopupList();

    // setInterval(() => {
    //   this.getHotMatchList(false);
    // }, 5000);

    // setInterval(() => {
    //   this.checkCommingList();
    // }, 1000);
  },
  methods: {
    updateBoardTab(tab) {
      this.boardTab = tab;
    },
    getBoardList(type) {
      this.$axios.get(`/web/common/board?page=1&size=8&type=${type}`, {}).then(res => {
        type === '공지사항' ? (this.noticeList = res.data.data) : (this.eventList = res.data.data);
      });
    },
    getPopupList() {
      this.$axios.get('/web/common/board?type=팝업').then(res => {
        res.data.forEach(x => {
          if (!this.$cookies.get(`popup_${x.ibd_idx}`)) {
            this.popupList.push(x);
          }
        });
        this.popupBoxWidth();
      });
    },
    popupBoxWidth() {
      if (this.popupList.length === 0) {
        this.$refs.popupBox.style.width = '0px';
      }
      if (this.popupList.length === 1) {
        this.$refs.popupBox.style.width = '542px';
      }
      if (this.popupList.length === 2) {
        this.$refs.popupBox.style.width = '1084px';
      }
      if (this.popupList.length >= 3) {
        this.$refs.popupBox.style.width = '1626px';
      }
    },
    getRealtimeTsList() {
      this.$axios.get('/web/live/transaction?type=deposit').then(res => {
        if (res) {
          this.depositList = res.data;
        }
      });

      this.$axios.get('/web/live/transaction?type=withdrawal').then(res => {
        if (res) {
          this.withdrawalList = res.data;
        }
      });
    },
    getHotMatchList(isFirst) {
      this.$axios.get('/web/sports/match?page=1&size=999&isHot=1&gameType=cross').then(res => {
        if (res) {
          this.hotMatchInitList = res.data.data;
          this.hotMatchList = res.data.data;

          if (this.hotSports !== '') {
            this.hotMatchList = this.hotMatchList.filter(x => x.ism_sports_name === this.hotSports);
          }

          this.hotSportsTypeList = [];
          this.hotMatchInitList.forEach(x => {
            if (!this.hotSportsTypeList.find(t => t.name === x.ism_sports_name)) {
              this.hotSportsTypeList.push({ name: x.ism_sports_name, count: 1 });
            } else {
              this.hotSportsTypeList.find(t => t.name === x.ism_sports_name).count = this.hotSportsTypeList.find(t => t.name === x.ism_sports_name).count + 1;
            }
          });

          if (isFirst) {
            setTimeout(() => {
              this.scrollHotList(true);
            }, 500);
          }
        }
      });
    },
    getLiveMatchList() {
      this.$axios.get('/web/sports/match?page=1&size=20&gameType=cross').then(res => {
        if (res) {
          this.liveMatchInitList = res.data.data;
          this.liveMatchList = res.data.data;

          this.liveMatchInitList.forEach(x => {
            if (!this.liveSportsTypeList.find(t => t.name === x.ism_sports_name)) {
              this.liveSportsTypeList.push({ name: x.ism_sports_name, count: 1 });
            } else {
              this.liveSportsTypeList.find(t => t.name === x.ism_sports_name).count++;
            }
          });
          setTimeout(() => {
            this.scrollLiveList(true);
          }, 500);
        }
      });
    },
    changeHotSports(sports) {
      this.hotSports = sports;

      if (sports === '') {
        return (this.hotMatchList = this.hotMatchInitList);
      }

      this.hotMatchList = this.hotMatchInitList.filter(x => x.ism_sports_name === sports);
      setTimeout(() => {
        this.scrollHotList(false);
      }, 500);
    },
    changeLiveSports(sports) {
      this.liveSports = sports;

      if (sports === '') {
        return (this.liveMatchList = this.liveMatchInitList);
      }

      this.liveMatchList = this.liveMatchInitList.filter(x => x.ism_sports_name === sports);
      setTimeout(() => {
        this.scrollLiveList(false);
      });
    },
    scrollHotList(isFirst) {
      // this.$refs.hotMatchList.style.transition = '';
      // this.$refs.hotMatchList.style.top = '0px';
      // const hotListHeight = this.$refs.hotMatchList.clientHeight;
      // setTimeout(() => {
      //   if (hotListHeight > 140) {
      //     this.$refs.hotMatchList.style.transition = `all ${(this.hotMatchList.length - 4) * 2}s ease`;
      //     this.$refs.hotMatchList.style.top = `${140 - hotListHeight}px`;
      //     if (isFirst) {
      //       setTimeout(
      //         () => {
      //           this.scrollHotList();
      //         },
      //         (this.hotMatchList.length - 4) * 2000,
      //       );
      //     }
      //   }
      // }, 500);
    },
    scrollLiveList(isFirst) {
      // if (this.$refs.liveMatchList && this.$refs.liveMatchList.style) {
      //   this.$refs.liveMatchList.style.transition = '';
      //   this.$refs.liveMatchList.style.top = '0px';
      //   const liveListHeight = this.$refs.liveMatchList.clientHeight;
      //   setTimeout(() => {
      //     if (liveListHeight > 140) {
      //       this.$refs.liveMatchList.style.transition = `all ${(this.liveMatchList.length - 4) * 2}s ease`;
      //       this.$refs.liveMatchList.style.top = `${140 - liveListHeight}px`;
      //       if (isFirst) {
      //         setTimeout(
      //           () => {
      //             this.scrollLiveList();
      //           },
      //           (this.liveMatchList.length - 4) * 2000,
      //         );
      //       }
      //     }
      //   }, 500);
      // }
    },
    openTelegram() {
      window.open(`https://t.me/${this.$store.state.siteConfig.isc_telegram.replace('@', '')}`, '_blank');
    },
    getLotteryData() {
      this.$axios.get('/web/config/lottery').then(res => {
        if (res) {
          this.lotteryData = res.data.data;
        }
      });
    },
    playCasinoGame(prId, gameId) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('system.loadingData'),
        background: 'rgba(0, 0, 0, 0.7)',
      });

      this.$axios.get(`/casino/kg/play/${prId}/${gameId}`).then(res => {
        if (res.data.code) {
          window.open(`${res.data.playUrl}`, 'PlayCasino', 'height=630,width=1000,menubar=no,toolbar=no,location=no,resizable=yes,status=no,scrollbars=no');
        } else {
          this.$alert(res.data.message);
        }
        loading.close();
      });
    },
    launchCasinoGame(gameId, type) {
      const status = this.gameConfig.find(x => x.game_code === gameId).game_status;
      const message = this.gameConfig.find(x => x.game_code === gameId).check_time;
      if (status === 0) {
        return this.$alert(message);
      }
      window.open(
        `https://mom-cdn.com/v1/casino/kplay/live?prdId=${gameId}&type=${type}&isMobile=${isMobile()}&x-access-token=${localStorage.getItem('accessToken')}`,
        'game',
        'height=1000,width=1600,menubar=no,toolbar=no,location=no,resizable=yes,status=no,scrollbars=no,left=100, top=100',
      );
    },
    launchSlotGame(gameId, type) {
      const status = this.gameConfig.find(x => x.game_provider === 'slot').game_status;
      const message = this.gameConfig.find(x => x.game_provider === 'slot').check_time;
      if (status === 0) {
        return this.$alert(message);
      }
      window.open(
        `https://mom-cdn.com/${this.$store.state.memberData.id}/slots/${gameId}/${type}?isMobile=${isMobile()}`,
        'PlaySlot',
        'height=630,width=1000,menubar=no,toolbar=no,location=no,resizable=yes,status=no,scrollbars=no',
      );
    },
    checkCommingList() {
      this.liveMatchList.forEach(x => {
        if (x.ism_start_datetime < this.$moment().format('YYYY-MM-DD HH:mm:ss')) {
          this.liveMatchList = this.liveMatchList.filter(t => t !== x);
        }
      });
    },
    closePopup(idx) {
      if (this.$refs[`popup_${idx}`].checked) {
        this.$cookies.set(`popup_${idx}`, true);
      }
      this.popupList = this.popupList.filter(x => x.ibd_idx !== idx);
      if (this.popupList.length === 0) {
        this.popupBoxWidth();
      }
    },
  },
};
</script>
